export const TOPBAR_HEIGHT = 68;
export const SIDEBAR_WIDTH = 240;
export const CONTENT_PADDING = 32;

export const COMMENT_AVATAR_SIZE = 42;
export const COMMENT_AVATAR_PADDING = 14;



// WEBPACK FOOTER //
// ./src/settings/metrics.js